import gql from 'graphql-tag'

export const PRODUCT_FILTER_FRAGMENT = gql`
  fragment productFilter on ProductFilter {
    id
    title
    description
    group
    usage
    measure {
      description
      title
    }
    type
    values {
      ... on ProductFilterItemsValues {
        items {
          count
          css
          isActive
          title
          valueId
          valueUrlKey
        }
      }
      ... on ProductFilterRangeValues {
        abs
        user
        percentiles
      }
    }
  }
`
